<template>
  <v-container> Sign Out... </v-container>
</template>

<script>
export default {
  name: "SignOut",
  created() {
    this.$store.dispatch("authentication/setSignOutTime").finally(() => {
      this.$store.commit("REMOVE_TOKEN");
      this.$router.push("/sign-in");
    });
  },
};
</script>
